import { Alert } from 'antd';
import dayjs from 'dayjs';
import type { ReportSummary } from '../reports.api';

/** Only a report read from a materialised view can be older than the clock; a live one says nothing. */
export function RefreshedStamp({ report }: { report: Pick<ReportSummary, 'source' | 'refreshedAt' | 'refreshFailedAt'> }) {
  if (report.source !== 'view') return null;
  const updated = report.refreshedAt ? `Updated ${dayjs(report.refreshedAt).format('D MMM, HH:mm')}` : 'Not refreshed yet';
  return (
    <div className="mb-4 flex flex-col gap-2">
      <p className="text-sm text-muted">{updated}</p>
      {report.refreshFailedAt && (
        <Alert
          type="warning"
          showIcon
          title="The last refresh failed"
          description="These figures are older than they should be. The records below are no newer than the figures."
        />
      )}
    </div>
  );
}
